import { ChangeDetectorRef, Component } from "@angular/core";

import { VehiclesHandlerService } from "../../../../api-handlers/vehicles-handler.service";
import { Vehicle } from "../../../../models/vehicle";

@Component({
  selector: "app-vehicle-search",
  templateUrl: "./vehicle-search.component.html",
  styleUrls: ["./vehicle-search.component.css"],
})
export class VehicleSearchComponent {
  plateVal: string = "";
  foundVehicle: Vehicle = null;
  noVehicleFound: boolean = false;
  failedValue: string = "";

  constructor(
    private changeDetector: ChangeDetectorRef,
    private vehiclesService: VehiclesHandlerService
  ) {}

  async onVehicleSearchClick() {
    try {
      const vehicleSearchRes: Vehicle =
        await this.vehiclesService.getDetailsByPlate(this.plateVal);

      this.foundVehicle = vehicleSearchRes;
      this.noVehicleFound = false;
    } catch (error) {
      this.noVehicleFound = true;
      this.foundVehicle = null;
      this.failedValue = this.plateVal;
    } finally {
      this.changeDetector.detectChanges();
    }
  }
}
